import React from 'react';
import { Award, Heart, Shield, Users } from 'lucide-react';
import { aboutContent, images } from '@/data/mock';

const features = [
  {
    icon: Heart,
    title: 'Passion & Dévouement',
    description: 'Un élevage fondé sur l\'amour des félins et le respect de leur bien-être.'
  },
  {
    icon: Shield,
    title: 'Santé Garantie',
    description: 'Tests ADN systématiques et suivi vétérinaire rigoureux pour chaque chat.'
  },
  {
    icon: Award,
    title: 'Excellence LOOF',
    description: 'Tous nos chats sont enregistrés au Livre Officiel des Origines Félines.'
  },
  {
    icon: Users,
    title: 'Accompagnement',
    description: 'Conseils personnalisés et suivi après adoption pour une intégration réussie.'
  }
];

export const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm uppercase tracking-wider text-[var(--color-gold)] font-medium mb-4">
            Notre Histoire
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[var(--text-primary)] mb-6">
            {aboutContent.title}
          </h2>
          <div className="w-24 h-px bg-[var(--color-gold)] mx-auto mb-8"></div>
          <p className="text-lg text-[var(--text-secondary)] max-w-3xl mx-auto leading-relaxed">
            {aboutContent.description}
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {aboutContent.highlights.map((stat, index) => (
            <div
              key={index}
              className="text-center p-8 bg-[var(--surface-cream)] rounded-2xl hover-lift"
            >
              <div className="text-4xl sm:text-5xl font-serif font-medium text-[var(--color-gold)] mb-3">
                {stat.number}
              </div>
              <h3 className="text-lg font-medium text-[var(--text-primary)] mb-2">
                {stat.label}
              </h3>
              <p className="text-sm text-[var(--text-subtle)]">
                {stat.description}
              </p>
            </div>
          ))}
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group">
              <div className="feature-icon mb-5 group-hover:scale-105 transition-transform">
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="font-medium text-[var(--text-primary)] mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-[var(--text-subtle)] leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Royal Canin Partnership */}
        <div className="mt-20 p-8 sm:p-12 bg-[var(--surface-cream)] rounded-2xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex-1 text-center md:text-left">
              <span className="text-sm uppercase tracking-wider text-[var(--color-gold)] font-medium">
                Partenariat Officiel
              </span>
              <h3 className="font-serif text-2xl sm:text-3xl text-[var(--text-primary)] mt-2 mb-4">
                Une alimentation d'excellence
              </h3>
              <p className="text-[var(--text-secondary)] leading-relaxed">
                Nous travaillons en partenariat avec Royal Canin pour garantir 
                une nutrition optimale à tous nos chats, de la naissance à l'âge adulte.
              </p>
            </div>
            <div className="flex-shrink-0">
              <img
                src={images.royalCanin}
                alt="Royal Canin - Partenaire"
                className="h-16 sm:h-20 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
